/**
 * Kształt panelu harmonogramu w kroku W2 — jedno miejsce dla treści i szkieletu,
 * bo obie strony muszą schodzić pod listę wariantów w tym samym momencie.
 *
 * Progi liczą się od szerokości **karty kroku** (`@container`), nie okna.
 * 860 px to chwila, w której panel przestaje mieścić się obok wariantów;
 * 700 px to próg całej karty — poniżej niego każdy blok siada na `px-4`.
 */
export const schedulePanelClass =
  '@max-[860px]:w-full @max-[860px]:border-l-0 @max-[860px]:border-t @max-[700px]:px-4 w-[420px] shrink-0 border-l border-neutral-100 bg-neutral-50 px-6 pb-[22px] pt-[18px]';
